export const TypeAngles = {
    "Apto 72.04 m²": 20
}